import { __extends } from "tslib";
import { AbstractionBase, AbstractMethodError } from '@awayjs/core';
/**
 * @class RenderableListItem
 */
var _Pick_PickableBase = /** @class */ (function (_super) {
    __extends(_Pick_PickableBase, _super);
    /**
     *
     * @param renderable
     * @param sourceEntity
     * @param surface
     * @param renderer
     */
    function _Pick_PickableBase(traversable, pickEntity) {
        var _this = _super.call(this, traversable, pickEntity) || this;
        //store references
        _this._node = pickEntity.node;
        _this._view = pickEntity.view;
        _this._pickGroup = pickEntity.pickGroup;
        pickEntity.addPickable(_this);
        return _this;
    }
    _Pick_PickableBase.prototype.onClear = function (event) {
        this._pool.removePickable(this);
        _super.prototype.onClear.call(this, event);
        //this.sourceEntity = null;
        this._view = null;
    };
    _Pick_PickableBase.prototype.hitTestPoint = function (x, y, z) {
        throw new AbstractMethodError();
    };
    _Pick_PickableBase.prototype.getBoxBounds = function (matrix3D, strokeFlag, cache, target) {
        if (matrix3D === void 0) { matrix3D = null; }
        if (strokeFlag === void 0) { strokeFlag = true; }
        if (cache === void 0) { cache = null; }
        if (target === void 0) { target = null; }
        return target;
    };
    _Pick_PickableBase.prototype.getSphereBounds = function (center, matrix3D, strokeFlag, cache, target) {
        if (matrix3D === void 0) { matrix3D = null; }
        if (strokeFlag === void 0) { strokeFlag = true; }
        if (cache === void 0) { cache = null; }
        if (target === void 0) { target = null; }
        return target;
    };
    _Pick_PickableBase.prototype.testCollision = function (collision, closestFlag) {
        throw new AbstractMethodError();
    };
    return _Pick_PickableBase;
}(AbstractionBase));
export { _Pick_PickableBase };
